import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab, FormControl, FormControlLabel, Grid, IconButton, InputAdornment, InputBase, InputLabel, MenuItem, Paper, Select, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import TextsmsIcon from '@mui/icons-material/Textsms';
import SendIcon from '@mui/icons-material/Send';
import { useParams } from 'react-router-dom';
import { actualizarTarea, actualizarTareaTaller, getExtras } from '../../services/apis';
import AutocompleteList from '../../utils/componentes-utiles/AutocompleteList';
import AddIcon from '@mui/icons-material/Add';
import { ArticulosExtra } from './ArticulosExtra';
import { refactorizarTlf } from '../../utils/utils';

export const FormEditarTareaTaller = ({ open, setOpen, tareaInfo, handleEvent, backgroundCard, textColor, opclientes, cargarTareas, opTrabajadores, trabajadores, estados }) => {
    const handleClose = () => {
        setOpen(false);
    };

    const param = useParams();


    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState([]);
    const [extras, setExtras] = useState([]);
    const [nuevoExtra, setNuevoExtra] = useState({
        descripcion: '',
        precio: null
    });
    // Estados locales para los campos del formulario

    const [tarea, setTarea] = useState(tareaInfo);



    const handleChange = (event) => {
        if (event.target.name === "minutos") {
            let value = parseInt(event.target.value, 10);

            if (value >= 0 && value <= 59) {
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            } else {
                // Si el valor es inválido, ajustamos a 59 o 0.
                value = value > 59 ? 59 : 0;
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            }
        } else if (event.target.name === "horas") {
            let value = parseInt(event.target.value, 10);

            if (value >= 0) {
                // No hay límite máximo para horas
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            } else {
                // Aseguramos que no sea negativo, ajustando a 0 si lo es.
                value = 0;
                const tareaNueva = { ...tarea, [event.target.name]: value };
                setTarea(tareaNueva);
            }
        }
        else {
            const tareaNueva = { ...tarea, [event.target.name]: event.target.value };
            setTarea(tareaNueva);
        }
    };
    const cargarExtras = async (idTarea) => {
        try {
            const response = await getExtras(idTarea);
            console.log(response);

            if (response.success) {
                setExtras(response.data)
            }

        } catch (error) {
            console.error("Error:", error);
        }
    }

    useEffect(() => {
        cargarExtras(tarea.id)
        let clienteSeleccionado = opclientes.filter(opcion => tareaInfo.id_cliente == opcion.value);
        setClienteSelec(clienteSeleccionado[0]);
    }, [])


    // Función para manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        // Aquí se puede manejar el envío de los datos (ejemplo: llamada a una API o validación)
        // Cierra el formulario
        editarTarea();
        handleClose();
    };

    const editarTarea = async () => {
        const nuevaTareaTmp = { ...tarea };
        nuevaTareaTmp.id_cliente = clienteSelec.value;
        nuevaTareaTmp.trabajadores = trabajadorSelec;
        // nuevaTareaTmp.telefono = refactorizarTlf(nuevaTareaTmp.telefono);
        nuevaTareaTmp.extras = extras;
        try {
            const response = await actualizarTareaTaller(nuevaTareaTmp);
            if (response.success == true) {
                cargarTareas();
                setTarea(
                    {
                        'fecha': new Date(),
                        'asunto': '',
                        'descripcion': '',
                        'localizacion': '',
                        'id_cliente': null,
                        'cliente': null,
                        'minutos': '',
                        'cargador': null,
                        'funda': null,
                        'maletin': null,
                        'tipo_parte': null,

                    });
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" })
            }


        } catch (error) {
            console.error("Error cargar tareas", error)
        }
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
            fullWidth
            maxWidth='xl'
        >
            <DialogTitle id="form-dialog-title">
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    xs={12}
                >
                    Editar Parte
                    <CancelIcon onClick={handleClose} sx={{ cursor: 'pointer', fontSize: 35 }} />
                </Grid>

            </DialogTitle>

            <DialogContent style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <form onSubmit={handleSubmit}>

                    <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        xs={12}
                    >

                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={5.5}
                            gap={2}
                            sx={{ pt: 1 }}
                        >
                            <FormControl fullWidth>
                                <InputLabel id="estado-select-label">Tipo de parte</InputLabel>
                                <Select
                                    labelId="estado-select-label"
                                    id="estado-select"
                                    name="tipo_parte"
                                    label="Tipo de parte"
                                    value={tarea.tipo_parte} // Asegura un valor predeterminado
                                    onChange={handleChange}
                                    fullWidth
                                >
                                    <MenuItem value={1}>Dispositivo</MenuItem>
                                    <MenuItem value={2}>Otro</MenuItem>
                                </Select>
                            </FormControl>

                            <TextField
                                label="Fecha"
                                type="datetime-local"
                                id="dateInput"
                                name="fechaDesde"
                                // className={filtros.fechaDesde ? "inputDateInput" : 'inputDateInput-empty'}
                                required
                                value={tarea.fecha} // Se establece la fecha de hoy si compra.Fecha es null
                                onChange={handleChange}
                                fullWidth
                            />

                            <TextField
                                label="Telefono"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="telefono"
                                value={tarea.telefono}
                                onChange={handleChange}
                                required
                            />

                            <TextField
                                label="Asunto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="asunto"
                                value={tarea.asunto}
                                onChange={handleChange}
                                required
                            />

                            <TextField
                                label="Dispositivo"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="dispositivo"
                                value={tarea.dispositivo}
                                onChange={handleChange}
                                required={tarea.tipo_parte === 1 ? true : false}
                            />

                            <FormControlLabel control={<Checkbox checked={tarea.dispositivo_entregado} onChange={(event) => setTarea({ ...tarea, 'dispositivo_entregado': event.target.checked })} />} label="Dispositivo en el taller" />


                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                xs={12}
                            >
                                <Grid item xs={12} >
                                    <InputLabel id="demo-simple-select-label" sx={{ mb: 1 }}>Presupuesto</InputLabel>
                                </Grid>

                                <Grid item xs={8} justifyContent={'start'} alignItems={'start'}>
                                    <TextField
                                        label="Presupuesto en €"
                                        variant="outlined"
                                        multiline
                                        fullWidth
                                        name="presupuesto"
                                        value={tarea.presupuesto}
                                        onChange={handleChange}

                                    />
                                </Grid>

                                <Grid container xs={3} justifyContent={'end'} alignItems={'center'}>
                                    <FormControl fullWidth>
                                        <InputLabel id="estado-select-label">IVA &nbsp;</InputLabel>
                                        <Select
                                            labelId="estado-select-label"
                                            id="estado-select"
                                            name="iva"
                                            label="IVA"
                                            value={tarea.iva} // Asegura un valor predeterminado
                                            onChange={handleChange}
                                        >
                                            <MenuItem value={1}>Si</MenuItem>
                                            <MenuItem value={2}>No</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <TextField
                                label="Comentario Presupuesto"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="comentario_presupuesto"
                                value={tarea.comentario_presupuesto}
                                onChange={handleChange}
                                required={tarea.id_estado >= 2 && tarea.id_estado <= 5 || tarea.id_estado == 7 ? true : false}

                            />
                        </Grid>

                        <Grid
                            container
                            direction="column"
                            justifyContent="start"
                            alignItems="start"
                            xs={5.5}
                            gap={2}
                            sx={{ pt: 1 }}
                        >
                            <Autocomplete
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opclientes}
                                // sx={{ width: 300 }}
                                value={clienteSelec}
                                onChange={(event, newValue) => setClienteSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Cliente*" />}
                                fullWidth
                            />

                            <TextField
                                label="Nombre Cliente"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="nombre_cliente"
                                value={tarea.nombre_cliente}
                                onChange={handleChange}
                                required
                            />

                            <TextField
                                label="Correo"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="correo"
                                value={tarea.correo}
                                onChange={handleChange}
                            />

                            <TextField
                                label="contraseña"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="contrasena"
                                value={tarea.contrasena}
                                onChange={handleChange}
                                required={tarea.tipo_parte === 1 ? true : false}
                            />

                            <Select
                                label="Estado"
                                id="demo-simple-select-standard"
                                labelId="demo-simple-select-filled-label"
                                disabled
                                name="id_estado"
                                value={tarea.id_estado}
                                onChange={handleChange}
                                fullWidth

                            >
                                {estados.map((estado) => (
                                    <MenuItem key={estado.id} value={estado.id}>{estado.nombre}</MenuItem>
                                ))}

                            </Select>

                            <FormControlLabel control={<Checkbox checked={tarea.pieza_pedida} onChange={(event) => setTarea({ ...tarea, 'pieza_pedida': event.target.checked })} />} label="Pieza pedida" />

                            <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                xs={12}
                            >
                                <Grid item xs={12}>
                                    <InputLabel id="demo-simple-select-label" sx={{ mb: 1 }}>Elementos entregados</InputLabel>
                                </Grid>
                                {console.log(tarea)
                                }
                                <Grid container xs={3} justifyContent={'center'} >
                                    <FormControl fullWidth>
                                        <InputLabel id="estado-select-label">Cargador</InputLabel>
                                        <Select
                                            labelId="estado-select-label"
                                            id="estado-select"
                                            name="cargador"
                                            label='Cargador'
                                            value={tarea.cargador} // Asegura un valor predeterminado
                                            onChange={handleChange}

                                        >
                                            <MenuItem value={0}>No</MenuItem>
                                            <MenuItem value={1}>Sí</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid container xs={3} justifyContent={'center'}>
                                    <FormControl fullWidth>
                                        <InputLabel id="estado-select-label">Funda</InputLabel>

                                        <Select
                                            labelId="estado-select-label"
                                            id="estado-select"
                                            name="funda"
                                            label='Funda'
                                            value={tarea.funda} // Asegura un valor predeterminado
                                            onChange={handleChange}

                                        >
                                            <MenuItem value={0}>No</MenuItem>
                                            <MenuItem value={1}>Sí</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid container xs={3} justifyContent={'center'}>
                                    <FormControl fullWidth>
                                        <InputLabel id="estado-select-label">Maletin/Bolsa</InputLabel>
                                        <Select
                                            labelId="estado-select-label"
                                            id="estado-select"
                                            name="maletin"
                                            label='Maletin/Bolsa'
                                            value={tarea.maletin} // Asegura un valor predeterminado
                                            onChange={handleChange}

                                        >
                                            <MenuItem value={0}>No</MenuItem>
                                            <MenuItem value={1}>Sí</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid
                                    container
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    xs={12}
                                    sx={{ mt: 2 }}
                                >
                                    <Grid container xs={10}>
                                        <TextField
                                            label="Otro elemento"
                                            variant="outlined"
                                            multiline
                                            fullWidth
                                            name="otorelemento"
                                            value={tarea.otorelemento}
                                            onChange={handleChange}
                                            required
                                        />
                                    </Grid>
                                    <Fab size='large' color="primary">
                                        <AddIcon />
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} marginTop={"1em"}>
                            <TextField
                                label="Descripción"
                                variant="outlined"
                                multiline
                                rows={4}
                                fullWidth
                                name="descripcion"
                                value={tarea.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>

                        <ArticulosExtra
                            extras={extras}
                            setExtras={setExtras}
                            nuevoExtra={nuevoExtra}
                            setNuevoExtra={setNuevoExtra}
                            idTarea={tarea.id}
                        >
                        </ArticulosExtra>
                    </Grid>

                    {/* <Grid item>
                        <Button variant="contained" component="label">
                            Subir Archivos
                            <input
                                type="file"
                                hidden
                                multiple
                                onChange={handleArchivoChange}
                            />
                        </Button>

                        {archivos && archivos.length > 0 && (
                            <div style={{ marginTop: '10px' }}>
                                {archivos.map((archivo, index) => (
                                    <span key={index} style={{ display: 'block' }}>
                                        {archivo.name}
                                    </span>
                                ))}
                            </div>
                        )}
                    </Grid> */}
                </form>
            </DialogContent>

            <DialogActions style={{
                backgroundColor: "#" + backgroundCard,
                color: textColor
            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Editar Parte
                </Button>
            </DialogActions>
        </Dialog>
    );
};